import { Component } from 'react';
import cookie from 'react-cookies';
import { animateScroll } from 'react-scroll';

class CustomFunctions extends Component {
    getDateTime = dateTime => {
        const today = new Date(dateTime);
        const date = `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`;
        const time = `${today.getHours() % 12 || 12}:${today.getMinutes()}:${today.getSeconds()}`;
        const ampm = today.getHours() >= 12 ? 'PM' : 'AM';
        return `${date} ${time} ${ampm}`;
    };

    getDate = dateTime => {
        //eslint-disable-line
        const today = new Date(dateTime);
        const date = `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`;
        return date;
    };

    jsonParse = jsonString => {
        try {
            return JSON.parse(jsonString);
        } catch (error) {
            return jsonString;
        }
    };

    capitalizeFirst = s => {
        if (!s) return '';
        if (typeof s !== 'string') return '';
        return s.charAt(0).toUpperCase() + s.slice(1);
    };

    getCurrencyCode = () => {
        return 'LBP';
    };

    getCurrencySymbol = (currency = '') => {
        let symbol = '';
        switch (currency.toUpperCase()) {
            case 'USD':
                symbol = '$';
                break;
            case 'LBP':
                symbol = 'ل.ل.';
                break;
            default:
                symbol = '$';
        }
        return symbol;
    };

    getUserId = async () => {
        const id = await cookie.load('userId');
        return id;
    };

    titleSubString = (str, len = 100) => {
        if (!str) return '';

        return str.substring(0, len) + (str.length > len ? '...' : '');
    };

    getScrollCond = () => {
        if (
            (window.innerWidth <= 760 &&
                window.innerHeight + document.documentElement.scrollTop >=
                    document.documentElement.offsetHeight - 25) ||
            window.innerHeight + document.documentElement.scrollTop === document.documentElement.offsetHeight
        ) {
            return true;
        }
        return false;
    };

    scrollTo = (value, options = null) => {
        animateScroll.scrollTo(value, options);
    };

    scrollToBottom = (options = null) => {
        animateScroll.scrollToBottom(options);
    };

    scrollToTop = (options = null) => {
        animateScroll.scrollToTop(options);
    };

    capitalize = s => {
        if (!s) return '';
        if (typeof s !== 'string') return '';
        return s.charAt(0).toUpperCase() + s.slice(1);
    };

    setHeaderTitle = (title = '') => {
        if (document.getElementsByClassName('header-title').length > 0) {
            document.getElementsByClassName('header-title')[0].innerText = title;
        }
    };

    countryCodeMasking = value => {
        const newValue = value.split('+');
        if (newValue[1]) {
            let newVal = newValue[1].replace(/\D/g, '').replace(/^0+/, '');
            if (newVal.length === 0) {
                newVal = '';
            } else if (newVal.length > 3) {
                newVal = newVal.substring(0, 3);
            }
            return `+${newVal}`;
        }
        let newVal = value.replace(/^0+/, '').replace(/\D/g, '+');
        if (newVal.length === 0) {
            newVal = '';
        } else if (newVal.length) {
            if (!newVal.startsWith('+')) {
                newVal = `+${newVal}`;
            }
        } else if (newVal.length > 3) {
            newVal = newVal.substring(0, 3);
        }
        return newVal;
    };

    parseToInt = value => {
        return parseInt(value, 10);
    };
}

export default new CustomFunctions();
